import React from "react";

function WarningIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33331 3.66659H7.66665V4.99992H6.33331V3.66659ZM6.99998 10.3333C7.36665 10.3333 7.66665 10.0333 7.66665 9.66659V6.99992C7.66665 6.63325 7.36665 6.33325 6.99998 6.33325C6.63331 6.33325 6.33331 6.63325 6.33331 6.99992V9.66659C6.33331 10.0333 6.63331 10.3333 6.99998 10.3333ZM6.99998 0.333252C3.31998 0.333252 0.333313 3.31992 0.333313 6.99992C0.333313 10.6799 3.31998 13.6666 6.99998 13.6666C10.68 13.6666 13.6666 10.6799 13.6666 6.99992C13.6666 3.31992 10.68 0.333252 6.99998 0.333252ZM6.99998 12.3333C4.05998 12.3333 1.66665 9.93992 1.66665 6.99992C1.66665 4.05992 4.05998 1.66659 6.99998 1.66659C9.93998 1.66659 12.3333 4.05992 12.3333 6.99992C12.3333 9.93992 9.93998 12.3333 6.99998 12.3333Z"
        fill="#A5A8AA"
      />
    </svg>
  );
}

export default WarningIcon;
